const DOCUMENT = 'NOTIFICATIONS_CENTER_';

const actions = {
  ASSIGN_REQUEST: DOCUMENT + 'ASSIGN_REQUEST',
  ASSIGN_SUCCESS: DOCUMENT + 'ASSIGN_SUCCESS',
  CHANGE_PROPERTIES: DOCUMENT + 'CHANGE_PROPERTIES',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  LOAD_ADMINISTRATORS_REQUEST: DOCUMENT + 'LOAD_ADMINISTRATORS_REQUEST',
  LOAD_ADMINISTRATORS_SUCCESS: DOCUMENT + 'LOAD_ADMINISTRATORS_SUCCESS',
  LOAD_DATA_REQUEST: DOCUMENT + 'LOAD_DATA_REQUEST',
  LOAD_DATA_SUCCESS: DOCUMENT + 'LOAD_DATA_SUCCESS',
  LOAD_TOP_NAV_NOTIFICATIONS_REQUEST: DOCUMENT + 'LOAD_TOP_NAV_NOTIFICATIONS_REQUEST',
  LOAD_TOP_NAV_NOTIFICATIONS_SUCCESS: DOCUMENT + 'LOAD_TOP_NAV_NOTIFICATIONS_SUCCESS',
  RESOLVE_NOTIFICATION: DOCUMENT + 'RESOLVE_NOTIFICATION',
  SUBSCRIBE: DOCUMENT + 'SUBSCRIBE',
  SUBSCRIBE_SUCCESS: DOCUMENT + 'SUBSCRIBE_SUCCESS',
  TOGGLE_ASSIGN_ADMIN_MODAL: DOCUMENT + 'TOGGLE_ASSIGN_ADMIN_MODAL',
  TOGGLE_SUBSCRIPTION_CATEGORY_MODAL: DOCUMENT + 'TOGGLE_SUBSCRIPTION_CATEGORY_MODAL',
  UNASSIGN_REQUEST: DOCUMENT + 'UNASSIGN_REQUEST',
  UNASSIGN_SUCCESS: DOCUMENT + 'UNASSIGN_SUCCESS',
  UNRESOLVE_NOTIFICATION: DOCUMENT + 'UNRESOLVE_NOTIFICATION',
  UNSUBSCRIBE: DOCUMENT + 'UNSUBSCRIBE',
  UNSUBSCRIBE_SUCCESS: DOCUMENT + 'UNSUBSCRIBE_SUCCESS',

  loadTopNavNotificationsRequest: () => {
    return {
      type: actions.LOAD_TOP_NAV_NOTIFICATIONS_REQUEST,
    };
  },

  loadTopNavNotificationsSuccess: data => {
    return {
      type: actions.LOAD_TOP_NAV_NOTIFICATIONS_SUCCESS,
      payload: data,
    };
  },

  loadData: data => {
    return {
      type: actions.LOAD_DATA_REQUEST,
      payload: data,
    };
  },

  loadAdministratorsRequest: () => {
    return {
      type: actions.LOAD_ADMINISTRATORS_REQUEST,
    };
  },

  loadAdministratorsSuccess: data => ({
    type: actions.LOAD_ADMINISTRATORS_SUCCESS,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_DATA_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  changeProperties: data => ({
    type: actions.CHANGE_PROPERTIES,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  resolveNotification: payload => ({
    type: actions.RESOLVE_NOTIFICATION,
    payload,
  }),

  unresolveNotification: payload => ({
    type: actions.UNRESOLVE_NOTIFICATION,
    payload,
  }),

  toggleSubscriptionCategoryModal: payload => ({
    type: actions.TOGGLE_SUBSCRIPTION_CATEGORY_MODAL,
    payload,
  }),

  toggleAssignAdminModal: payload => ({
    type: actions.TOGGLE_ASSIGN_ADMIN_MODAL,
    payload,
  }),

  unsubscribe: payload => ({
    type: actions.UNSUBSCRIBE,
    payload,
  }),

  unsubscribeSuccess: payload => ({
    type: actions.UNSUBSCRIBE_SUCCESS,
    payload,
  }),

  subscribe: payload => ({
    type: actions.SUBSCRIBE,
    payload,
  }),

  subscribeSuccess: payload => ({
    type: actions.SUBSCRIBE_SUCCESS,
    payload,
  }),

  assignRequest: payload => ({
    type: actions.ASSIGN_REQUEST,
    payload,
  }),

  assignSuccess: () => ({
    type: actions.ASSIGN_SUCCESS,
  }),

  unassignRequest: payload => ({
    type: actions.UNASSIGN_REQUEST,
    payload,
  }),

  unassignSuccess: () => ({
    type: actions.UNASSIGN_SUCCESS,
  }),
};

export default actions;
